export interface ILogger {
  fatal: (error: unknown, message?: string) => void;
  error: (error: unknown, message?: string) => void;
  warning: (message: string) => void;
  log: (message: string) => void;
  info: (message: string) => void;
  debug: (message: string) => void;
}
